import React, { useState } from 'react';
import '../../styles/modal.css';
import { IcoCalendar, IcoPencil, IcoTrash } from '../dashboard/DashIcons';
import ConfirmDeleteModal from '../modals/ConfirmDeleteModal';

const WorkHistoryModal = ({ name, entries, onClose, onDelete, onEdit }) => {
  const [confirmDelete, setConfirmDelete] = useState(null);

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}><IcoCalendar size={18} color="#22c55e"/> Work History — {name}</h2>
        <ul>
          {entries.map((entry) => (
            <li key={entry._id}>
              {entry.hoursWorked} hrs on {new Date(entry.date).toLocaleDateString(undefined, { timeZone: 'UTC' })} ({entry.notes || 'No notes'})
              <br />
              <button onClick={() => onEdit(entry)} title="Edit"><IcoPencil size={14}/></button>
              <button onClick={() => setConfirmDelete({ id: entry._id })} style={{ marginLeft: '0.5rem' }} title="Delete"><IcoTrash size={14}/></button>
            </li>
          ))}
        </ul>
        <button onClick={onClose}>Close</button>
      </div>
      {confirmDelete && (
        <ConfirmDeleteModal
          message="Are you sure you want to delete this entry? This cannot be undone."
          onConfirm={() => { onDelete(confirmDelete.id); setConfirmDelete(null); }}
          onCancel={() => setConfirmDelete(null)}
        />
      )}
    </div>
  );
};

export default WorkHistoryModal;
